import React from "react";
import GlassPanel from "@/components/GlassPanel";

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-6 md:px-12 py-16" data-testid="about-page">
      <div className="gps-tag mb-4">SYSTEM DOCUMENTATION</div>
      <h1 className="gps-heading text-4xl md:text-6xl">PHILOSOPHY</h1>
      <p className="text-mute max-w-3xl mt-6 text-base leading-relaxed">
        GPS is not a workout tracker. It is not a fitness app. It is a universal language for
        physical capability — a standardized way to measure, compare, and define human physicality
        at planetary scale.
      </p>

      <div className="grid md:grid-cols-2 gap-6 mt-12">
        <GlassPanel className="p-8">
          <h2 className="gps-heading text-2xl text-white">QDR FRAMEWORK</h2>
          <p className="text-mute text-sm mt-4 leading-relaxed">
            Every test is calibrated on three anchor values:
          </p>
          <ul className="mt-4 space-y-3 gps-mono text-sm">
            <li><span className="text-white">Q</span> — Minimum valid measurable performance · score 0</li>
            <li><span className="text-white">D</span> — Approximately the top 10% of the physically capable general population · score 50 (separate values for men and women)</li>
            <li><span className="text-white">R</span> — Peak known human performance · score 100 (universal upper bound)</li>
          </ul>
          <p className="text-mute text-sm mt-4 leading-relaxed">
            Scores are normalized through non-linear progression curves to reflect real athletic
            improvement — getting to elite is exponentially harder than crossing the median.
          </p>
        </GlassPanel>

        <GlassPanel className="p-8">
          <h2 className="gps-heading text-2xl text-white">SCORING SYSTEM</h2>
          <p className="text-mute text-sm mt-4 leading-relaxed">
            Each of the 10 tests produces a 0–100 score. The two tests within each pillar are averaged
            to produce a pillar score. The five pillar scores average into your overall GPS.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-2">
            {[
              ["TEST SCORES", "0 – 100"],
              ["PILLARS", "5 axes"],
              ["GPS OVERALL", "0 – 100"],
              ["ARCHETYPE", "1 of 32"],
            ].map(([k, v]) => (
              <div key={k} className="border border-white/15 rounded-lg p-3">
                <div className="gps-label">{k}</div>
                <div className="gps-mono text-white">{v}</div>
              </div>
            ))}
          </div>
        </GlassPanel>

        <GlassPanel className="p-8">
          <h2 className="gps-heading text-2xl text-white">5 PILLARS</h2>
          <ul className="mt-4 space-y-2 text-sm">
            <li><span className="gps-mono text-white w-10 inline-block">S</span> Strength — force production</li>
            <li><span className="gps-mono text-white w-10 inline-block">F</span> Speed — pure velocity</li>
            <li><span className="gps-mono text-white w-10 inline-block">E</span> Explosive — power per millisecond</li>
            <li><span className="gps-mono text-white w-10 inline-block">P</span> Stamina — sustained output</li>
            <li><span className="gps-mono text-white w-10 inline-block">C</span> Control — neural calculation</li>
          </ul>
        </GlassPanel>

        <GlassPanel className="p-8">
          <h2 className="gps-heading text-2xl text-white">PHYSICAL CULTURE VISION</h2>
          <p className="text-mute text-sm mt-4 leading-relaxed">
            GPS exists to create a planet-scale standard for physical capability — a shared
            vocabulary that lets athletes, gyms, scientists, and federations speak the same
            language about the human body.
          </p>
          <p className="text-mute text-sm mt-3 leading-relaxed">
            Test yourself. Get scored. Find your archetype. Compete globally. Evolve.
          </p>
        </GlassPanel>
      </div>
    </div>
  );
}
